import { Exception } from "./Exception";

export class DuplicateException extends Exception {
  constructor() {
    super("Duplicate entry.");
  }
}
